<template>
  <div class="table-wrap" ref="tableWrapRef">
    <el-table
      class="my-table"
      style="width: 100%"
      :data="tableData"
      :row-key="rowKey"
      border
      v-loading="loading"
      ref="tableRef"
      :max-height="tableHeight"
      @selection-change="handleSelectionChange"
      @sort-change="changeTableSort"
      :row-class-name="rowClassNameFn ? rowClassNameFn : classNameFun"
      v-bind="$attrs"
      v-on="$listeners"
      :show-summary="summary"
      :summary-method="getSummaries"
      @select-all="selectAll"
      @select="select"
    >
      <!-- 多选框 -->
      <el-table-column
        v-if="selection"
        type="selection"
        :width="selectableWidth ? selectableWidth : '55'"
        :reserve-selection="true"
        :selectable="selectable"
      >
      </el-table-column>

      <el-table-column
        v-if="isIndex"
        label="序号"
        :width="indexWidth ? indexWidth : 55"
        type="index"
      ></el-table-column>

      <template v-for="(item, index) in tableInfo">
        <!-- 展开收起 -->
        <el-table-column
          v-if="item.type == 'scalable'"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :key="'scalable' + showOverflowObj['showOverflow' + index] + index"
        >
          <template slot="header">
            {{ item.label }}
            <y-button
              @click="showOverflowClick(index)"
              type="blueText"
              v-if="!item.notIcon"
            >
              {{ showOverflowText(index)
              }}<i
                :class="
                  showOverflowObj['showOverflow' + index]
                    ? 'el-icon-arrow-up'
                    : 'el-icon-arrow-down'
                "
                style="margin: -3px 0"
              ></i>
            </y-button>
          </template>
          <template slot-scope="scope">
            <el-tooltip
              v-if="!showOverflowObj['showOverflow' + index]"
              effect="dark"
              :content="scope.row[item.prop]"
              placement="top"
            >
              <div :class="isTowShow ? 'isTowShowText' : 'hoveTitle'">
                {{ scope.row[item.prop] }}
              </div>
            </el-tooltip>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <!-- 带问号标识提示的 -->
        <el-table-column
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :key="'tips' + index"
          v-else-if="item.type == 'tips'"
        >
          <template slot="header">
            <div
              :style="
                'display: flex; align-items: center;justify-content: ' +
                item.align +
                ';'
              "
            >
              {{ item.label }}
              <el-tooltip
                effect="dark"
                :content="item.tipsContent"
                placement="top-start"
                :popper-class="getHeaderTooltipClass(item)"
              >
                <template slot="content" v-if="item.isTipsSlot">
                  <div v-html="item.tipsContent"></div>
                </template>
                <img
                  src="@/assets/new-image/header/quest.svg"
                  style="
                    width: 14px;
                    height: 14px;
                    cursor: pointer;
                    margin-left: 4px;
                  "
                  alt=""
                />
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <!-- 操作列统一处理 -->
        <el-table-column
          v-else-if="item.type == 'operate'"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :key="'operate' + index"
          fixed="right"
        >
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
          </template>
        </el-table-column>
        <!-- 二级 -->
        <el-table-column
          v-else-if="item.type == 'expand'"
          :key="'expand' + index"
          :type="item.type"
        >
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
          </template>
        </el-table-column>
        <!-- 插槽以及普通类 -->
        <el-table-column
          v-else-if="!item.notShow"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :key="index"
          :show-overflow-tooltip="
            showOverflowTooltip || item.showOverflowTooltip
          "
        >
          <template #header="scope" v-if="item.slotHead">
            <slot :name="item.slotHead" :column="scope.column"></slot>
          </template>
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
            <template v-else-if="item.formatter">
              {{ item.formatter(scope.row, item) }}
            </template>
            <template v-else-if="item.enum">
              {{ item.enum[scope.row[item.prop]] || scope.row[item.prop] }}
            </template>
            <!-- 普通类型内容 -->
            <template v-else>
              <div>
                <!-- 兼容两行 -->
                <div
                  :class="{
                    textHidden: !item.textWrap && !isTowShow,
                  }"
                >
                  {{ scope.row[item.prop] ? scope.row[item.prop] : "-" }}
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
      <!-- 用于显示多级合计 -->
      <slot v-if="!tableInfo.length" />
      <template slot="empty" v-if="isDefaultEmpty">
        <div class="flex" style="margin-bottom: 98px; margin-top: 71px">
          <img
            src="@/assets/new-image/nodata/empty.png"
            style="width: 186px; height: 114px"
          />
          <span class="notDataText">暂无数据</span>
        </div>
      </template>
      <template slot="empty" v-else>
        <slot name="empty"></slot>
      </template>
    </el-table>
    <!-- 分页组件 -->
    <div class="table-wrap-page" v-if="showPage && tableTotal > 9">
      <el-pagination
        style="text-align: right"
        :current-page="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10, 30, 50, 100, 1000]"
        :background="background"
        :layout="layout"
        :total="tableTotal"
        :pager-count="pagerCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    layout: {
      type: String,
      default: "total, prev, pager, next,sizes, jumper",
    },
    pagerCount: {
      type: Number,
      default: 7,
    },
    tableInfo: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    reserveSelection: {
      type: Boolean,
      default: false,
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    // 分页信息
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        };
      },
    },
    // 多选列
    selection: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      // 换页也勾选中（数据唯一值）
      type: null,
      default: "",
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false,
    },
    // 没有数据时显示提示
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    // 自适应高度
    autoMaxHeight: {
      type: Boolean,
      default: true,
    },
    //  当内容过长被隐藏时显示 tooltip
    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },

    // 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    selectable: {
      type: Function,
      default: (row, index) => {
        return (row, index) => {
          return true;
        };
      },
    },
    selectableWidth: {
      type: String,
    },
    //分页器的背景色
    background: {
      type: Boolean,
      default: true,
    },
    //使用默认的空数据提示
    isDefaultEmpty: {
      type: Boolean,
      default: true,
    },
    // 是否两行显示
    isTowShow: {
      type: Boolean,
      default: false,
    },
    // 是否开启合计
    summary: {
      type: Boolean,
      default: false,
    },
    // 合计数据
    summaryObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否需要序号列
    isIndex: {
      type: Boolean,
      default: false,
    },
    // 序号列宽度
    indexWidth: {
      type: Number,
      default: 50,
    },
    // 多级合计数组
    summaryArr: {
      type: Array,
      default: () => [],
    },
    // 列表类样式函数
    rowClassNameFn: {
      type: Function,
    },
  },
  data() {
    return {
      ids: [],
      tabDataPageTotal: 1000,
      showOverflowObj: {},
      tableHeight: null,
    };
  },
  watch: {
    summaryArr(newVal) {
      if (newVal.length) {
        this.tabDataPageTotal = this.tableData.length;
        this.summaryArr.map((item) => {
          this.tableData.push(item);
        });
      }
    },
  },
  created() {
    this.tableInfo.map((item, index) => {
      if (item.type == "scalable") {
        this.showOverflowObj["showOverflow" + index] = false;
      }
    });
  },
  computed: {
    tableTotal() {
      return Number(this.pageInfo.total) || 0;
    },
    ...mapGetters(["scaleValue"]),
    getHeaderTooltipClass() {
      return (config) => {
        return config.tooltipScale && this.scaleValue > 1
          ? "last-header-tooltip-popper"
          : "";
      };
    },
  },
  mounted() {
    if (this.autoMaxHeight) {
      this.getMaxHeight();
      window.addEventListener("resize", this.getMaxHeight);
    }
  },
  methods: {
    getMaxHeight() {
      this.$nextTick(() => {
        if(this.showPage){
          this.tableHeight = this.$refs.tableWrapRef.clientHeight - 50;
        }else{
          this.tableHeight = this.$refs.tableWrapRef.clientHeight
        }
      });
    },
    showOverflowText(index) {
      return this.showOverflowObj["showOverflow" + index] ? "收起" : "展开";
    },
    classNameFun({ rowIndex }) {
      let class1 = !this.isTowShow
        ? "tableRowClassNameOne"
        : "tableRowClassNameTow";
      let class2 = rowIndex <= this.tabDataPageTotal - 1 ? "" : "SummarClass";
      return class1 + " " + class2;
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.map((item, index) => {
        sums[index] = this.summaryObj[item.property] || "";
      });
      return sums;
    },
    showOverflowClick(index) {
      this.showOverflowObj["showOverflow" + index] =
        !this.showOverflowObj["showOverflow" + index];
      this.$forceUpdate();
    },
    handleClearSelection() {
      this.$refs.tableRef.clearSelection();
    },
    changeTableSort(val) {
      this.$emit("changeTableSort", val);
    },
    handleSelectionChange(val) {
      this.ids = [...val];
      this.$emit("selection-change", this.ids);
      this.$emit("handleSelectionChange", this.ids);
    },
    selectAll(val) {
      this.$emit("selectAll", val);
    },
    select(selection, row) {
      this.$emit("handleSelect", selection, row);
    },
    //分页
    handlePage(page) {
      this.$emit("handlePage", page);
    },
    handleSizeChange(val) {
      this.handlePage({ pageSize: val, pageNum: 1 });
    },
    handleCurrentChange(val) {
      console.log(this.pageInfo.pageSize, "112");

      this.handlePage({ pageSize: this.pageInfo.pageSize, pageNum: val });
    },
    toggleRowSelection(row, status = true) {
      let that = this;
      return that.$refs.tableRef.toggleRowSelection(row, status);
    },
    // 重置排序
    handleClearSort() {
      this.$refs.tableRef.clearSort();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMaxHeight);
  },
};
</script>

<style lang="scss">
.last-header-tooltip-popper{
  transform-origin: right!important;
}
</style>

<style lang="scss" scoped>
.table-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &-page {
    margin-top: 16px;
  }
}

// 使用深度选择器处理Element UI组件样式
/deep/ .el-table {
  &.el-table--border {
    .el-table-column--selection {
      .cell {
        border-right: none;
      }
    }

    // 处理表头
    thead tr th.el-table-column--selection {
      border-right: none;
    }

    // 处理表体
    tbody tr td.el-table-column--selection {
      border-right: none;
    }

    // 处理固定列
    .el-table-fixed-left {
      .el-table-column--selection {
        border-right: none;
      }
    }
  }
}

/deep/ .my-table {
  border: 1px solid #f2f2f2;
  border-bottom: none;
  border-radius: 4px;
  flex: none !important;
  color: $text-6;
  .el-table__header {
    height: 40px;
    th.el-table__cell {
      font-weight: 500;
      font-size: 12px;
      color: #333333;
      background: #f2f3f5;
      height: 40px;
    }
  }
  .tableRowClassNameOne {
    height: 40px;
  }
  .tableRowClassNameTow {
    height: 60px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
  }
  .SummarClass {
    > td {
      height: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      background: #f2f2f3;
    }
  }
  // 列表行
  .textHidden {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .textTowHidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 300px;
  }
  .el-table__footer-wrapper .el-table__footer .el-table__cell {
    font-weight: 600 !important;
  }

  .el-table__footer-wrapper .el-table__footer .el-table__cell:first-child {
    color: #333 !important;
  }
  .el-table .el-table__cell.gutter {
    background: #fafafa;
  }
}

::v-deep .el-table .el-table__cell {
  padding: 0px 0 1px 0;
}
.floatRight {
  float: right;
}
.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-box-orient: vertical;
}
.flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.notDataText {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #8186a5;
}
/deep/.has-gutter {
  > tr > td {
    height: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    background: #f2f2f3 !important;
  }
}
/deep/.el-pagination {
  font-weight: 400 !important;
  padding: 0 5px !important;
}
</style>
